import { Box, Chip, Typography } from "@mui/material";
import moment from "moment";
import React from "react";
import { convertDuration } from "../../../utils/helper";

const ShortContentCard = ({ clip }: any) => {
  return (
    <Box>
      <Box>
        <Box sx={{ position: "relative", overflow: "hidden" }}>
          <Box
            component={"img"}
            sx={{
              height: 180,
              width: 1,
              objectFit: "cover",
              transition: "transform 0.3s ease-in-out",

              "&:hover": {
                transform: "scale(1.03)",
                cursor: "pointer",
              },
            }}
            loading="lazy"
            src={clip.Thumbnail}
            alt={clip.Title}
          />
          <Box
            sx={{
              position: "absolute",
              bottom: 8,
              left: 8,
              right: 8,
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Box sx={{ display: "flex", gap: 0.5, flex: 1 }}>
                {clip.createdAt &&
                  !moment(clip.createdAt).isBefore(
                    moment().subtract(4, "days")
                  ) && (
                    <Chip
                      sx={{ borderRadius: "4px" }}
                      label={"New"}
                      color="primary"
                      size="small"
                    />
                  )}
              </Box>
              <Chip
                sx={{ mr: 2 }}
                label={convertDuration(clip?.Duration)}
                color="primary"
                size="small"
              />
            </Box>
          </Box>
        </Box>

        <Box sx={{ mt: 1 }}>
          <Box
            sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}
          >
            <Typography
              sx={{
                fontWeight: 600,
                fontStyle: "normal",
                textTransform: "none",
                fontSize: "14px",
              }}
              variant={"body2"}
            >
              {clip.Title}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              sx={{
                fontWeight: 400,
                fontStyle: "normal",
                textTransform: "none",
              }}
              variant="body2"
            >
              {clip?.Description}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            {clip?.ViewsCount > 0 && (
              <Typography
                sx={{
                  whiteSpace: "nowrap",
                  fontStyle: "normal",
                  fontWeight: 500,
                  textTransform: "none",
                }}
                variant="body2"
              >
                {clip?.ViewsCount + (clip?.ViewsCount > 1 ? " Views" : " View")}{" "}
                -
              </Typography>
            )}

            <Typography
              sx={{
                fontWeight: 400,
                fontStyle: "normal",
                color: "#474747",
                textTransform: "none",
              }}
              variant="body2"
            >
              {moment(clip.createdAt).fromNow()}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ShortContentCard;
